export const smsRegistrationConfirmation = 'smsRegistrationConfirmation'
export const smsViewingCreated = 'smsViewingCreated'
export const smsViewingChanges = 'smsViewingChanges'
export const smsEnNewCancelledViewing = 'smsEnNewCancelledViewing'
export const smsViewingAttendeeDayBeforeEnabled =
  'smsViewingAttendeeDayBeforeEnabled'
export const smsLeaseOffer = 'smsLeaseOffer'
export const smsRequestInformation = 'smsRequestInformation'
export const enableBackgroundCheckBundle = 'enableBackgroundCheckBundle'
export const enableKeyManagement = 'enableKeyManagement'
export const enableTravelTimeOptimisationOption =
  'enableTravelTimeOptimisationOption'
export const enableViewingExcludeCalendarEventsTime =
  'enableViewingExcludeCalendarEventsTime'

export const viewing_book_nearby_properties_enabled =
  'viewing_book_nearby_properties_enabled'

export const enable_assign_property_to_building =
  'enable_assign_property_to_building'

export const enquiry_sms_response = 'enquiry_sms_response'

export const userMFAConfigSms = 'user_mfa_config_sms'
export const userMFAConfigEmail = 'user_mfa_config_email'

export const enableAIPayslipsAnalysis = 'smart_docs_payslip_enabled'
export const enableAIRentalLedgerAnalysis = 'smart_docs_rental_ledger'
export const enableDisplayAIAnalysis = 'smart_docs_display_analysis'
export const enableBankStatementRedaction = 'bank_statement_redaction_enabled'
export const enableGroupBundle = 'groupBundleEnabled'

export const paidPlans = [
  smsRegistrationConfirmation,
  smsViewingCreated,
  smsViewingChanges,
  smsEnNewCancelledViewing,
  smsViewingAttendeeDayBeforeEnabled,
  smsLeaseOffer,
  smsRequestInformation,
  enableBackgroundCheckBundle,
  enableKeyManagement,
  enableTravelTimeOptimisationOption,
  enableViewingExcludeCalendarEventsTime,
  enquiry_sms_response,
  userMFAConfigSms,
  userMFAConfigEmail,
]

export const multiple_office_agency_reporting_owner =
  'multiple_office_agency_reporting_owner'
export const agency_reporting_owner_guid = `${multiple_office_agency_reporting_owner}_guid`
export const agency_reporting_owner_name = `${multiple_office_agency_reporting_owner}_name`

export const multiple_office_agency_prospecting_follow_team =
  'multiple_office_agency_prospecting_follow_team'
export const agency_prospecting_follow_team_guid = `${multiple_office_agency_prospecting_follow_team}_guid`
export const agency_prospecting_follow_team_name = `${multiple_office_agency_prospecting_follow_team}_name`

export const isAdmin = 'isAdmin'
export const isFinance = 'isFinance'
export const isCasualInspector = 'isCasualInspector'
export const isLeasingConsultant = 'isLeasingConsultant'
export const isPropertyManager = 'isPropertyManager'
export const isBDM = 'isBDM'
export const isTeamLeader = 'isTeamLeader'
